import { useSyncExternalStore } from 'react';

// Singleton printing store inlined to avoid multiple files and ensure
// global print listeners are registered only once.
let printing = false;
const listeners = new Set<() => void>();
let initialized = false;

const notify = (): void => {
  listeners.forEach((cb) => cb());
};

const handleBeforePrint = (): void => {
  printing = true;
  notify();
};

const handleAfterPrint = (): void => {
  printing = false;
  notify();
};

const init = (): void => {
  if (initialized) return;
  initialized = true;
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);
  }
};

const teardown = (): void => {
  if (!initialized) return;
  if (typeof window !== 'undefined' && window.removeEventListener) {
    window.removeEventListener('beforeprint', handleBeforePrint);
    window.removeEventListener('afterprint', handleAfterPrint);
  }
  initialized = false;
};

const getPrinting = (): boolean => {
  init();
  return printing;
};

const subscribePrinting = (cb: () => void) => {
  init();
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
    if (listeners.size === 0) {
      teardown();
    }
  };
};

const usePrinting = () => {
  return useSyncExternalStore(subscribePrinting, getPrinting);
};

export default usePrinting;
